exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".gateway-card .card-media-image {\n  width: 16px;\n  height: 18px;\n  margin-top: 5px; }\n\n.gateway-card .card-media-title {\n  float: left;\n  padding-right: 20px; }\n\n.gateway-card .card-media-text .btn {\n  text-transform: none; }\n\n.gateway-card .toolbar {\n  float: left;\n  padding-left: 20px;\n  margin-left: 20px;\n  border-left: 1px solid #ccc; }\n\n.gateway-card .gateway-ips {\n  font-weight: bold;\n  font-size: 12px; }\n\n.gateway-card .gateway-details {\n  font-size: 12px; }\n\n.gateway-card .ext-nw-ip {\n  padding-left: 20px;\n  line-height: 12px; }\n\n.gateway-card .gateway-config {\n  text-transform: capitalize; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/network/gateways/gateways.scss
// module id = 1DoM
// module chunks = 0